import React, { useEffect } from 'react';
import '../styles/ImpactNumbers.css';

function OurStory() {
  useEffect(() => {
    const titleElement = document.querySelector('.impact-title');
    if (titleElement) {
      titleElement.classList.add('animate-in');
    }
  }, []);

  return (
    <section className="impact-section1">
      <div className="impact-image-container">
        <img 
          src="/assets/images/ourstory.png" 
          alt="Biking impact" 
          className="impact-background-image" 
        />
      </div>
    </section>
  );
}

export default OurStory;